import { newConfig } from '../config';
import config from '../config';
import { toRaw } from 'vue';

const appConfig = config();
const { v1 } = appConfig.apiVersion;

export default class TicketGroupService {
  constructor(client) {
    this.client = client;
  }

  async findOne(ticketGroupId) {
    return this.client.get(
      `${newConfig.services.proxy.url}${newConfig.services.proxy.core}/${v1}/ticket-groups/${ticketGroupId}`
    );
  }

  async getTicketGroupTickets(ticketGroupId, params = {}) {
    const formattedParams = JSON.parse(JSON.stringify(toRaw(params)));
    return this.client.get(
      `${newConfig.services.proxy.url}${newConfig.services.proxy.core}/${v1}/ticket-groups/${ticketGroupId}/tickets`,
      { params: formattedParams }
    );
  }
}
